/**
 * Site-wide footer with copyright. Shown on all pages including landing, auth, and app.
 */
export function Footer() {
  return (
    <footer className="border-t bg-muted/30 py-4">
      <div className="container text-center text-sm text-muted-foreground">
        Copyright © 2025 Pink Dolphin Cards. All rights reserved.
      </div>
    </footer>
  );
}
